import { getMomentTz } from "@dexteel/mesf-core";
import { Grid2 as Grid, InputAdornment, Paper, TextField } from "@mui/material";
import { HeatData } from "../models/HeatReportModels";
import { useTableStyles } from "../styles/useTableStyles";
import { getHeatStatus } from "../utils/getHeatStatus";
import { HeatNavigatorWithSearch } from "./controls/HeatNavigatorWithSearch";
interface Props {
	heat: HeatData;
	getDataFromAPI: (heatId: number | null) => void;
}
const moment = getMomentTz();
export const HeaderHeatDataReport = ({ heat, getDataFromAPI }: Props) => {
	const classes = useTableStyles();
	return (
		<Paper elevation={0} style={{ border: "1px solid #ccc" }}>
			<Grid container spacing={2} sx={{ p: 1 }}>
				{/* Column 1*/}
				<Grid
					size={{ xs: 12, sm: 6, md: 3 }}
					container
					spacing={1}
					key="col-heat-number"
				>
					<Grid size={{ xs: 12 }} key="heat-number" alignContent="center">
						<HeatNavigatorWithSearch
							value={heat}
							onChange={(heatId) => {
								getDataFromAPI(heatId);
							}}
							onBlur={() => {}}
							showNext={!!heat.NextHeatId}
							showPrevious={!!heat.PreviousHeatId}
							onNext={(heatId) => {
								getDataFromAPI(heatId);
							}}
							onPrevious={(heatId) => {
								getDataFromAPI(heatId);
							}}
							onLast={() => {
								getDataFromAPI(null);
							}}
						/>
					</Grid>
				</Grid>
				{/* Column 2 */}
				<Grid
					size={{ xs: 12, sm: 6, md: 3 }}
					container
					spacing={1}
					key="col-main-data-1"
				>
					<Grid
						size={{ xs: 12 }}
						container
						direction="row"
						spacing={1}
						alignContent="flex-start"
					>
						<Grid size={{ xs: 12 }} key="tap-time">
							<TextField
								label="Tap Time"
								value={
									heat.TapDate
										? `${moment(heat.TapDate).format("HH:mm - MM/DD/YYYY ")} - Shift ${heat.TapShift} - Crew ${heat.TapCrew}`
										: ""
								}
								variant="outlined"
								fullWidth
								onChange={() => {}}
							/>
						</Grid>
						<Grid size={{ xs: 12 }} key="open-time">
							<TextField
								label="Open"
								value={
									heat.OpenDate
										? `${moment(heat.OpenDate).format("HH:mm - MM/DD/YYYY")} - Shift ${heat.OpenShift} - Crew ${heat.OpenCrew}`
										: ""
								}
								variant="outlined"
								fullWidth
								onChange={() => {}}
							/>
						</Grid>
					</Grid>
				</Grid>

				{/* Column 3 */}
				<Grid
					size={{ xs: 12, sm: 6, md: 3 }}
					container
					spacing={1}
					key="col-main-data-2"
				>
					<Grid
						size={{ xs: 12 }}
						container
						direction="row"
						spacing={1}
						alignContent="flex-start"
					>
						<Grid size={{ xs: 12 }} key="ladle">
							<div className={classes.container}>
								<TextField
									className={`${classes.field} ${classes.leftField}`}
									label="Ladle"
									variant="outlined"
									size="small"
									value={heat.LadleName || ""}
								/>
								<TextField
									className={`${classes.field} ${classes.rightField}`}
									label="Ladle Life"
									variant="outlined"
									size="small"
									value={heat.HeatsOnLadle || ""}
								/>
							</div>
						</Grid>

						<Grid size={{ xs: 12 }} key="grade">
							<TextField
								label="Grade"
								value={heat.Grade ?? ""}
								variant="outlined"
								fullWidth
								onChange={() => {}}
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={{ xs: 3 }} key="final-status" container spacing={1}>
					<Grid size={{ xs: 12 }} key="final-status">
						<TextField
							label="Final Status"
							value={getHeatStatus(heat.FinalStatus ?? "").name}
							variant="outlined"
							fullWidth
							onChange={() => {}}
							InputProps={{
								endAdornment: (
									<InputAdornment position="start">
										<div
											style={{
												width: "26px",
												height: "26px",
												borderRadius: 4,
												display: "inline-flex",
												alignItems: "center",
												justifyContent: "center",
												color: "#fff",
												fontWeight: "bold",
												backgroundColor: heat.FinalStatus
													? getHeatStatus(heat.FinalStatus).color
													: "#ccc",
											}}
										>
											{heat.FinalStatus}
										</div>
									</InputAdornment>
								),
							}}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
};
